import { ActiveModel, ActiveField } from '@alt-point/active-models/src'
import { CdekCourierEstimatedDateIntervalsDto } from './CdekCourierEstimatedDateIntervalsDto'
/**
* Class CdekCourierEstimatedIntervalsDto
*  Ответ showcase `integrations/cdek/estimated-intervals`.
*/
export class CdekCourierEstimatedIntervalsDto extends ActiveModel {

/**
  * @property dates
  * Даты с доступными окнами (исчерпанные интервалы не включаются).  */
  @ActiveField({
    factory: [CdekCourierEstimatedDateIntervalsDto, () => []]
  })
  dates: Array<CdekCourierEstimatedDateIntervalsDto> = []
}
